export enum PropertyGender {
  MALE = 'male',
  FEMALE = 'female',
  MIXED = 'mixed'
}
